import React from 'react';
import { 
  Dialog, 
  DialogActions, 
  DialogContent, 
  DialogTitle,
  Button,
  TextField,
  Grid,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    fontWeight: 'bold',
    textAlign: 'center',
  },
  textField: {
    width: '100%',
    marginBottom: 16,
  },
}));

export default function EditMarathonScoreDialog({ 
  open, 
  handleClose, 
  score, 
  setScore,
  time,
  setTime,
  onSave,
}) {
  const classes = useStyles();

  const handleSave = () => {
    onSave();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="edit-score-dialog-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="edit-score-dialog-title" className={classes.dialogTitle}>
        ویرایش امتیاز و زمان
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="امتیاز"
              variant="outlined"
              type="number"
              value={score}
              onChange={(e) => setScore(e.target.value)}
              className={classes.textField}
              inputProps={{ min: 0 }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="زمان (ثانیه)"
              variant="outlined"
              type="number"
              value={time}
              onChange={(e) => setTime(e.target.value)}
              className={classes.textField}
              inputProps={{ min: 0 }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSave} color="primary" variant="contained">
          ذخیره
        </Button>
        <Button onClick={handleClose} color="secondary">
          انصراف
        </Button>
      </DialogActions>
    </Dialog>
  );
}
